<template>
  <div>
    <!-- 物流号添加 -->
    <el-dialog :title="$t('message.logisticsNumberAdded')" :close-on-click-modal="false"
      :visible.sync="$parent.addExpressDialogVisible" width="488px" center>
      <div class="content">
        <!-- 修改后交易号： -->
        <div class="label">
          {{ $t("message.newLogisticsNumber") }}
          ：
        </div>
        <div class="val">
          <el-input v-model="express_no" onfocus="this.select()"></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <!-- <el-button @click="$parent.addExpressDialogVisible = false">{{
          $t("message.cancel")
        }}</el-button> -->
        <!-- 保存 -->
        <el-button type="primary" @click="save">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    ids: { type: Array },
  },
  data() {
    return {
      express_no: "",
    };
  },
  methods: {
    // 保存
    save() {
      if (this.express_no == "")
        return this.$message.error(
          this.$t("message.pleaseEnterTheLogisticsNumber")
        );
      let datas = {
        orderPurchaseIdSet: this.ids,
        express_no: this.express_no,
      };
      this.$api.orderApi.addExpress(datas).then((res) => {
        this.$message.success(res.msg);

        this.$parent.wuliuSuccess();
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;
  display: flex;

  .label {
    flex: 1;
    line-height: 40px;
  }

  .val {
    flex: 3;
  }
}
</style>